var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.667 9H6.332v1.333h1.333V9ZM7 1.667A5.34 5.34 0 0 1 12.333 7 5.34 5.34 0 0 1 7 12.333 5.34 5.34 0 0 1 1.667 7 5.34 5.34 0 0 1 7 1.667Zm0 12A6.667 6.667 0 1 0 7 .332a6.667 6.667 0 0 0 0 13.335Zm.667-10H6.332v4h1.333v-4Z",
  fill: "#D65F5C"
})));
export default SvgInfoError;